import React from 'react';
import { Alert, Box, Paper, Stack, Typography } from '@mui/material';
import { PageLayout } from '@retail/components';
import { useAppTFunction } from '@retail/app/i18n';
import { PermissionsTable } from './PermissionsTable';
import { TagHeading } from '@shared/components';

export const PermissionsPage: React.FC = () => {
  const t = useAppTFunction();

  return (
    <PageLayout maxWidth="full" fixedHeight>
      <Paper
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Stack spacing={2} p={3} pb={2} alignItems="center" direction="row" whiteSpace="nowrap">
          <Stack>
            <TagHeading color="success">
              <Typography variant="h4" component="h1">
                {t('app.routes.permissions')}
              </Typography>
            </TagHeading>
          </Stack>
          <Alert severity="warning">This page is only visible to super users</Alert>
        </Stack>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            maxHeight: '100%',
            position: 'relative',
          }}
        >
          <Box sx={{ position: 'absolute', inset: 0 }}>
            <PermissionsTable />
          </Box>
        </Box>
      </Paper>
    </PageLayout>
  );
};
